import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class DelegationService {
  baseUrl = 'delegation';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  finish = (id) => BaseService.post({ url: `${this.baseUrl}/finish/${id}` });
  start = (id) => BaseService.post({ url: `${this.baseUrl}/start/${id}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  save = (delegation) => BaseService.post({ url: `${this.baseUrl}/save`, data: delegation });
  getById = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
}

export default new DelegationService();
